import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { IApiStart } from '../ApiTypes';
import LogoFW from '../components/LogoFW';
import styles from '../style/style.scss';

function MainPage() {
  const [title, setTitle] = useState<string>('Uruchamianie...');
  const [message, setMessage] = useState<string>('');
  const [startApiResponse, setStartApiResponse] = useState<IApiStart | null>(null);
  const navigate = useNavigate();
  // dowiedz się co mam robić?
  useEffect(() => {
    fetch('/api/v1/start')
      .then((r) => r.json())
      .then((data) => setStartApiResponse(data));
  }, []);

  // zrób to co masz zrobic
  useEffect(() => {
    if (startApiResponse == null) {
      return;
    }

    if (startApiResponse.type === 'register') {
      console.log('Zarejestruj urządzenie');
      navigate('/register');
      return;
    }

    if (startApiResponse.type === 'qr_config') {
      console.log('Wyświetl kod qr i konfiguruj urządzenie');
      navigate('/configure');
      return;
    }

    if (startApiResponse.type === 'install') {
      console.log('przenieś na stronę z instalacją');
      navigate('/install');
      return;
    }

    if (startApiResponse.type === 'start_app') {
      console.log('Uruchom aplikacje');
      navigate('/app');
      return;
    }

    setTitle('Błąd');
    setMessage(startApiResponse.message);
    throw Error(`wrong startApiResponse.type ${JSON.stringify(startApiResponse)}`);
  }, [startApiResponse]);

  return (
    <div className={styles.fwcontainer}>
      <LogoFW />
      <div className="mb-5" />
      <h1 className="display-1 text-center">{title}</h1>
      <div>{message}</div>
    </div>
  );
}

export default MainPage;
